import i18n from '../i18n/config';
export const exportExcelFileName = i18n.t('excel.fileName');
export const exportExcelSheetName = i18n.t('excel.sheetName');